import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CampaignIcon from "@mui/icons-material/Campaign";
import { PortfolioListAnnouncement, PortfolioGetUserAnnouncement } from "../../util/API/portfolio";
import { commonRunQuery } from "../../util/API/loans";



const Announcements = ({ userRole }) => {
  const [announcements, setAnnouncements] = useState([]);
  const [funds, setFunds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const authUser = JSON.parse(sessionStorage.getItem("user"));

  console.log("userRole============",userRole);
  console.log("authUser============",authUser?.userid);

  useEffect(() => {
    (async () => {
      const fundList = await fetchFunds();
      await fetchAnnouncements(fundList);
    })();
  }, []);

  const fetchFunds = async () => {
    try {
      const response = await commonRunQuery(359, "");
      const records = response?.data?.body?.record;
      if (!records) return [];
      const recordsArray = Array.isArray(records) ? records : [records];
      const mapped = recordsArray.map((item) => ({
        id: item.funds.id,
        name: item.funds.name,
      }));
      setFunds(mapped);
      return mapped;
    } catch (error) {
      console.error("Failed to fetch funds:", error);
      return [];
    }
  };

  // Turns an epoch/date string into a relative "2d ago" style label.
  // Falls back gracefully if the value can't be parsed.
  const timeAgo = (dateValue, serverTimeZone = "America/Toronto") => {
    if (!dateValue) return "";
  
    let then;
  
    if (typeof dateValue === "number" || !isNaN(Number(dateValue))) {
      const num = Number(dateValue);
      then = new Date(num < 1e11 ? num * 1000 : num);
    } else if (typeof dateValue === "string") {
      let str = dateValue.trim();
  
      // 1. If timestamp already includes ISO timezone ('Z' or '+05:30'), parse directly
      if (str.includes("Z") || /[+-]\d{2}:?\d{2}$/.test(str)) {
        then = new Date(str);
      } else {
        // 2. If it's a raw local string from the server (e.g., "2026-07-23 10:30:00")
        // We parse it using the server's time zone (e.g., America/Toronto or UTC)
        const cleanStr = str.replace(" ", "T");
        
        try {
          // Create a date assuming UTC, then adjust by server's zone offset
          const dummyDate = new Date(`${cleanStr}Z`);
          
          // Use Intl to get exact offset of the server's time zone dynamically (handles Daylight Saving automatically)
          const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: serverTimeZone,
            timeZoneName: "longOffset",
          });
          
          const parts = formatter.formatToParts(dummyDate);
          const timeZonePart = parts.find((p) => p.type === "timeZoneName")?.value; // e.g. "GMT-04:00"
          const offset = timeZonePart?.replace("GMT", "") || "Z";
  
          then = new Date(`${cleanStr}${offset}`);
        } catch (err) {
          // Fallback standard parse
          then = new Date(cleanStr);
        }
      }
    } else {
      then = new Date(dateValue);
    }
  
    if (isNaN(then.getTime())) return "";
  
    // Date.now() returns exact global UTC epoch time anywhere on Earth
    const diffMs = Date.now() - then.getTime();
  
    if (diffMs < 5000) return "just now";
  
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    const diffWeek = Math.floor(diffDay / 7);
  
    if (diffSec < 60) return "just now";
    if (diffMin < 60) return `${diffMin}m ago`;
    if (diffHr < 24) return `${diffHr}h ago`;
    if (diffDay < 7) return `${diffDay}d ago`;
    return `${diffWeek}w ago`;
  };

  const fetchAnnouncements = async (fundList = funds) => {
    setIsLoading(true);
    console.log("fetchAnnouncements_userRole=========",userRole);
    try {
      var response;
      if(userRole == "admin") {
        const now = new Date();
        const formattedDate = `${now.getFullYear()}-` + `${String(now.getMonth() + 1).padStart(2, "0")}-` + `${String(now.getDate()).padStart(2, "0")}` + ` ${String(now.getHours()).padStart(2, "0")}:` + `${String(now.getMinutes()).padStart(2, "0")}:` + `${String(now.getSeconds()).padStart(2, "0")}`;

        console.log("formattedDate============",formattedDate);
        response = await PortfolioListAnnouncement(
          "",
          "0",
          "",
          "",
          "",
          "0",
          formattedDate,
          "1"
        );
      } else {
        response = await PortfolioGetUserAnnouncement(
          "",
          authUser?.userid
        );
      }
      const records = response?.data?.body?.record;
      if (records) {
        const recordsArray = Array.isArray(records) ? records : [records];
        const mapped = recordsArray
          .map((item) => {
            console.log("item============",item.Announcements);
            const a = item.Announcements;
            if (!a) return null;
            const fundId = a.fund_id;
            const isAllInvestors = !fundId || fundId === "0" || fundId === 0;
            const audience = isAllInvestors
              ? "All Investors"
              : fundList.find((f) => String(f.id) === String(fundId))?.name ||
                "Specific Fund";

            return {
              id: a.id,
              title: a.title,
              body: a.content,
              audience,
              date: timeAgo(a.created_at || a.date_created || a.created),
              numberby: Number(a.numberby) || 0,
            };
          })
          .filter(Boolean)
          .sort((x, y) => Number(x.numberby) - Number(y.numberby) || Number(y.id) - Number(x.id));

        setAnnouncements(mapped);
      } else {
        setAnnouncements([]);
      }
    } catch (error) {
      console.error("Failed to fetch announcements:", error);
      setAnnouncements([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      className="dashboard-card"
      sx={{ height: 350, display: "flex", flexDirection: "column" }}
    >
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, flexShrink: 0 }}>
        Announcements
      </Typography>

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
          <CircularProgress size={24} />
        </Box>
      ) : announcements.length === 0 ? (
        <Typography variant="body2" color="textSecondary">
          No announcements yet.
        </Typography>
      ) : (
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            pr: 0.5,
            // Slim, unobtrusive scrollbar
            "&::-webkit-scrollbar": { width: 6 },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#d0d5dd",
              borderRadius: 3,
            },
            "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
          }}
        >
          {announcements.map((a) => (
            <Box
              key={a.id}
              onClick={() => setSelected(a)}
              sx={{
                cursor: "pointer",
                p: 1,
                mb: 1,
                borderRadius: 1,
                "&:hover": { bgcolor: "#f4f7f9" },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <CampaignIcon sx={{ fontSize: "1rem", color: "#001529" }} />
                <Typography variant="body2" fontWeight="bold" noWrap>
                  {a.title}
                </Typography>
              </Box>
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{
                  display: "block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {a.body}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
                <Chip label={a.audience} size="small" sx={{ height: 18, fontSize: "0.65rem" }} />
                <Typography variant="caption" color="textSecondary">
                  {a.date}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <Dialog open={!!selected} onClose={() => setSelected(null)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {selected?.title}
          <IconButton onClick={() => setSelected(null)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {selected?.body}
          </Typography>
          <Chip label={selected?.audience} size="small" />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Announcements;
